import React from 'react';
import '../EvaluationDesign.css';

const SkillGapTable = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="eval-gap-table">
            <div className="eval-table-container">
                <table className="eval-table">
                    <thead>
                        <tr>
                            <th style={{ color: 'var(--accent-blue)' }}>Compétence</th>
                            <th style={{ color: 'var(--accent-blue)', textAlign: 'center' }}>Niveau</th>
                            <th style={{ color: 'var(--accent-blue)', textAlign: 'center' }}>Niveau requis</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, idx) => (
                            <tr key={idx}>
                                <td style={{ fontWeight: 600, color: '#1e293b' }}>{item.skill}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <span className={`eval-score-circle lvl-${Math.min(Math.max(Math.round(item.obtenu || 0), 1), 4)}`}>
                                        {item.obtenu || 0}
                                    </span>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <span className="eval-num-requis">
                                        {item.requis || 0}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SkillGapTable;
